import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { MsalProvider } from "@azure/msal-react";
import { Configuration, PublicClientApplication } from "@azure/msal-browser";

const msalConfiguration = {
  auth: {
    clientId: "433844b8-4618-4c05-b8db-33002897fd58", // the only mandatory field in this object, uniquely identifies your app
    // here you'll add the other fields that you might need based on the Azure portal settings
    //redirectUri: "https://192.168.1.104:3000",
    authority:
      "https://login.microsoftonline.com/cf3c29b9-4880-43ba-950e-5a0b12780a83",
  },
};

const pca = new PublicClientApplication(msalConfiguration);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <MsalProvider instance={pca}>
    <React.StrictMode>
      <App />
    </React.StrictMode>
  </MsalProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
